import { createRouter, createWebHistory } from 'vue-router'
import AppShell from '@/layout/AppShell.vue'

const routes = [
  {
    path: '/',
    component: AppShell,
    redirect: '/platforms',
    children: [
      {
        path: '/platforms',
        name: 'platforms',
        component: () => import('@/views/platforms/index.vue'),
        meta: { title: '平台配置' },
      },
      {
        path: '/devices',
        name: 'devices',
        component: () => import('@/views/devices/index.vue'),
        meta: { title: '设备查询' },
      },
      {
        path: '/flow-analysis',
        name: 'flow-analysis',
        component: () => import('@/views/flow-analysis/index.vue'),
        meta: { title: '跑量分析' },
      },
      {
        path: '/charts',
        name: 'charts',
        component: () => import('@/views/charts/index.vue'),
        meta: { title: '图表绘制' },
      },
      {
        path: '/advanced-charts',
        name: 'advanced-charts',
        component: () => import('@/views/advanced-charts/index.vue'),
        meta: { title: '高级图表' },
      },
      {
        path: '/audit',
        name: 'audit',
        component: () => import('@/views/audit/index.vue'),
        meta: { title: '接口审计' },
      },
      {
        path: '/manual-draw',
        name: 'manual-draw',
        component: () => import('@/views/manual-draw/index.vue'),
        meta: { title: '手动绘图' },
      },
      {
        path: '/compare',
        name: 'compare',
        component: () => import('@/views/compare/index.vue'),
        meta: { title: '数据对比' },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${to.meta.title || '控制台'}`
  const token = localStorage.getItem('fzmetrics_login_token')
  if (to.path === '/login') {
    if (token) {
      return next('/platforms')
    }
    return next()
  }
  if (!token) {
    return next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    })
  }
  return next()
})

export default router
